<div class="flex flex-row user-option-content">
  <mat-icon class="user-icon" [style.color]="iconColor">account_circle</mat-icon>
  <span class="user-name-bubble">{{ name }}</span>
  <span class="user-separator" *ngIf="email"> – </span>
  <span class="user-email" *ngIf="email">{{ email }}</span>
</div>
